import styled from 'styled-components';

import { DurationIndicator, StoryStatus } from './DurationIndicator';

const Root = styled.div`
  width: 100%;
  display: flex;
  gap: var(--half-unit);
  padding: var(--double-unit);
  & > * {
    flex: 1;
  }
`;

type Props = {
  steps: number[];
  playing: boolean;
  currentlyPlayingStoryIndex: number;
  onStoryEnd: () => void;
  pause?: boolean;
};
export const DurationsIndicator = ({
  steps,
  playing,
  currentlyPlayingStoryIndex,
  onStoryEnd,
  pause,
}: Props) => {
  return (
    <Root>
      {steps.map((duration, i) => {
        let storyStatus;
        if (currentlyPlayingStoryIndex > i) {
          storyStatus = StoryStatus.SEEN;
        } else if (currentlyPlayingStoryIndex < i) {
          storyStatus = StoryStatus.NOT_SEEN;
        }

        return (
          <DurationIndicator
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            playing={playing && i === currentlyPlayingStoryIndex}
            storyStatus={storyStatus}
            duration={duration}
            onFinish={onStoryEnd}
            pause={pause}
          />
        );
      })}
    </Root>
  );
};
